const keyboardImage = (id) => `/images/hardware/keyboards/${id}.png`;
const keyboardVersion = (id, name) => ({ id, name, image: keyboardImage(id) });

export const KEYBOARDS_HARDWARE = [
  {
    id: "wooting-keyboards",
    name: "Wooting Keyboards",
    brand: "Wooting",
    type: "keyboard",
    category: "Claviers gaming",
    variants: [
      {
        id: "wooting-hall-effect",
        name: "Hall Effect / Analog",
        versions: [
          keyboardVersion("wooting-60he", "Wooting 60HE"),
          keyboardVersion("wooting-60he-v2", "Wooting 60HE v2"),
          keyboardVersion("wooting-80he", "Wooting 80HE"),
          keyboardVersion("wooting-two-he", "Wooting Two HE"),
        ],
      },
    ],
  },
  {
    id: "tryhard-keyboards",
    name: "Tryhard Keyboards",
    brand: "Tryhard",
    type: "keyboard",
    category: "Claviers gaming",
    variants: [
      {
        id: "tryhard-mechanical",
        name: "Claviers mecaniques",
        versions: [
          keyboardVersion("tryhard-keyboard", "Tryhard Keyboard"),
        ],
      },
    ],
  },
  {
    id: "razer-keyboards",
    name: "Razer Gaming Keyboards",
    brand: "Razer",
    type: "keyboard",
    category: "Claviers gaming",
    variants: [
      {
        id: "razer-huntsman",
        name: "Huntsman",
        versions: [
          keyboardVersion("razer-huntsman", "Razer Huntsman"),
          keyboardVersion("razer-huntsman-elite", "Razer Huntsman Elite"),
          keyboardVersion("razer-huntsman-mini", "Razer Huntsman Mini"),
          keyboardVersion("razer-huntsman-mini-analog", "Razer Huntsman Mini Analog"),
          keyboardVersion("razer-huntsman-signature", "Razer Huntsman Signature"),
          keyboardVersion("razer-huntsman-v2", "Razer Huntsman V2"),
          keyboardVersion("razer-huntsman-v2-pro", "Razer Huntsman V2 Pro"),
          keyboardVersion("razer-huntsman-v2-tkl", "Razer Huntsman V2 TKL"),
          keyboardVersion("razer-huntsman-v2-analog", "Razer Huntsman V2 Analog"),
          keyboardVersion("razer-huntsman-v3-pro", "Razer Huntsman V3 Pro"),
          keyboardVersion("razer-huntsman-v3-pro-tkl", "Razer Huntsman V3 Pro TKL"),
          keyboardVersion("razer-huntsman-v3-pro-mini", "Razer Huntsman V3 Pro Mini"),
        ],
      },
      {
        id: "razer-blackwidow",
        name: "BlackWidow",
        versions: [
          keyboardVersion("razer-blackwidow-chroma", "Razer BlackWidow Chroma"),
          keyboardVersion("razer-blackwidow-chroma-v2", "Razer BlackWidow Chroma V2"),
          keyboardVersion("razer-blackwidow-elite", "Razer BlackWidow Elite"),
          keyboardVersion("razer-blackwidow-v3", "Razer BlackWidow V3"),
          keyboardVersion("razer-blackwidow-v3-tenkeyless", "Razer BlackWidow V3 Tenkeyless"),
          keyboardVersion("razer-blackwidow-v3-mini-hyperspeed", "Razer BlackWidow V3 Mini HyperSpeed"),
          keyboardVersion("razer-blackwidow-v3-pro", "Razer BlackWidow V3 Pro"),
          keyboardVersion("razer-blackwidow-v4", "Razer BlackWidow V4"),
          keyboardVersion("razer-blackwidow-v4-x", "Razer BlackWidow V4 X"),
          keyboardVersion("razer-blackwidow-v4-75", "Razer BlackWidow V4 75%"),
          keyboardVersion("razer-blackwidow-v4-pro", "Razer BlackWidow V4 Pro"),
        ],
      },
      {
        id: "razer-deathstalker-ornata",
        name: "DeathStalker / Ornata",
        versions: [
          keyboardVersion("razer-deathstalker-v2", "Razer DeathStalker V2"),
          keyboardVersion("razer-deathstalker-v2-pro", "Razer DeathStalker V2 Pro"),
          keyboardVersion("razer-deathstalker-v2-pro-tkl", "Razer DeathStalker V2 Pro TKL"),
          keyboardVersion("razer-ornata-v2", "Razer Ornata V2"),
          keyboardVersion("razer-ornata-v3", "Razer Ornata V3"),
        ],
      },
    ],
  },
  {
    id: "logitech-g-keyboards",
    name: "Logitech G Gaming Keyboards",
    brand: "Logitech",
    type: "keyboard",
    category: "Claviers gaming",
    variants: [
      {
        id: "logitech-g-pro",
        name: "PRO / Esport",
        versions: [
          keyboardVersion("logitech-g-pro", "Logitech G PRO"),
          keyboardVersion("logitech-g-pro-x", "Logitech G PRO X"),
          keyboardVersion("logitech-g-pro-x-tkl", "Logitech G PRO X TKL"),
          keyboardVersion("logitech-g-pro-x-tkl-rapid", "Logitech G PRO X TKL RAPID"),
        ],
      },
      {
        id: "logitech-g-low-profile",
        name: "Low Profile",
        versions: [
          keyboardVersion("logitech-g815-lightsync", "Logitech G815 LIGHTSYNC"),
          keyboardVersion("logitech-g915-lightspeed", "Logitech G915 LIGHTSPEED"),
          keyboardVersion("logitech-g915-x-lightspeed", "Logitech G915 X LIGHTSPEED"),
          keyboardVersion("logitech-g915-x-lightspeed-tkl", "Logitech G915 X LIGHTSPEED TKL"),
          keyboardVersion("logitech-g515-lightspeed-tkl", "Logitech G515 LIGHTSPEED TKL"),
        ],
      },
      {
        id: "logitech-g-classics",
        name: "Classiques",
        versions: [
          keyboardVersion("logitech-g713", "Logitech G713"),
          keyboardVersion("logitech-g715", "Logitech G715"),
          keyboardVersion("logitech-g513", "Logitech G513"),
          keyboardVersion("logitech-g413-se", "Logitech G413 SE"),
          keyboardVersion("logitech-g610-orion", "Logitech G610 Orion"),
          keyboardVersion("logitech-g613-lightspeed", "Logitech G613 LIGHTSPEED"),
          keyboardVersion("logitech-g910-orion-spectrum", "Logitech G910 Orion Spectrum"),
        ],
      },
    ],
  },
  {
    id: "steelseries-keyboards",
    name: "SteelSeries Gaming Keyboards",
    brand: "SteelSeries",
    type: "keyboard",
    category: "Claviers gaming",
    variants: [
      {
        id: "steelseries-apex-pro",
        name: "Apex Pro",
        versions: [
          keyboardVersion("steelseries-apex-pro", "SteelSeries Apex Pro"),
          keyboardVersion("steelseries-apex-pro-tkl", "SteelSeries Apex Pro TKL"),
          keyboardVersion("steelseries-apex-pro-mini", "SteelSeries Apex Pro Mini"),
          keyboardVersion("steelseries-apex-pro-mini-wireless", "SteelSeries Apex Pro Mini Wireless"),
          keyboardVersion("steelseries-apex-pro-gen-3", "SteelSeries Apex Pro Gen 3"),
          keyboardVersion("steelseries-apex-pro-mini-gen-3", "SteelSeries Apex Pro Mini Gen 3"),
          keyboardVersion("steelseries-apex-pro-tkl-gen-3", "SteelSeries Apex Pro TKL Gen 3"),
        ],
      },
      {
        id: "steelseries-apex",
        name: "Apex",
        versions: [
          keyboardVersion("steelseries-apex-9-mini", "SteelSeries Apex 9 Mini"),
          keyboardVersion("steelseries-apex-9-tkl", "SteelSeries Apex 9 TKL"),
          keyboardVersion("steelseries-apex-7", "SteelSeries Apex 7"),
          keyboardVersion("steelseries-apex-7-tkl", "SteelSeries Apex 7 TKL"),
          keyboardVersion("steelseries-apex-5", "SteelSeries Apex 5"),
        ],
      },
    ],
  },
  {
    id: "corsair-keyboards",
    name: "Corsair Gaming Keyboards",
    brand: "Corsair",
    type: "keyboard",
    category: "Claviers gaming",
    variants: [
      {
        id: "corsair-k70",
        name: "K70",
        versions: [
          keyboardVersion("corsair-k70-rgb", "Corsair K70 RGB"),
          keyboardVersion("corsair-k70-rgb-mk2", "Corsair K70 RGB MK.2"),
          keyboardVersion("corsair-k70-rgb-tkl", "Corsair K70 RGB TKL"),
          keyboardVersion("corsair-k70-pro", "Corsair K70 PRO"),
          keyboardVersion("corsair-k70-pro-mini-wireless", "Corsair K70 PRO Mini Wireless"),
          keyboardVersion("corsair-k70-pro-tkl", "Corsair K70 PRO TKL"),
          keyboardVersion("corsair-k70-core", "Corsair K70 CORE"),
          keyboardVersion("corsair-k70-max", "Corsair K70 MAX"),
        ],
      },
      {
        id: "corsair-k-series",
        name: "K Series",
        versions: [
          keyboardVersion("corsair-k100-rgb", "Corsair K100 RGB"),
          keyboardVersion("corsair-k95-rgb-platinum", "Corsair K95 RGB Platinum"),
          keyboardVersion("corsair-k95-rgb-platinum-xt", "Corsair K95 RGB Platinum XT"),
          keyboardVersion("corsair-k65-rgb-mini", "Corsair K65 RGB Mini"),
          keyboardVersion("corsair-k65-plus-wireless", "Corsair K65 PLUS Wireless"),
          keyboardVersion("corsair-k60-rgb-pro", "Corsair K60 RGB PRO"),
          keyboardVersion("corsair-k60-pro-tkl", "Corsair K60 PRO TKL"),
          keyboardVersion("corsair-k63-wireless", "Corsair K63 Wireless"),
        ],
      },
    ],
  },
  {
    id: "asus-rog-keyboards",
    name: "ASUS ROG Gaming Keyboards",
    brand: "ASUS",
    type: "keyboard",
    category: "Claviers gaming",
    variants: [
      {
        id: "asus-rog-azoth",
        name: "Azoth",
        versions: [
          keyboardVersion("asus-rog-azoth", "ASUS ROG Azoth"),
          keyboardVersion("asus-rog-azoth-extreme", "ASUS ROG Azoth Extreme"),
        ],
      },
      {
        id: "asus-rog-falchion-scope",
        name: "Falchion / Scope",
        versions: [
          keyboardVersion("asus-rog-falchion", "ASUS ROG Falchion"),
          keyboardVersion("asus-rog-falchion-ace", "ASUS ROG Falchion Ace"),
          keyboardVersion("asus-rog-falchion-rx-low-profile", "ASUS ROG Falchion RX Low Profile"),
          keyboardVersion("asus-rog-strix-scope", "ASUS ROG Strix Scope"),
          keyboardVersion("asus-rog-strix-scope-rx", "ASUS ROG Strix Scope RX"),
          keyboardVersion("asus-rog-strix-scope-ii", "ASUS ROG Strix Scope II"),
          keyboardVersion("asus-rog-strix-scope-ii-96-wireless", "ASUS ROG Strix Scope II 96 Wireless"),
          keyboardVersion("asus-rog-strix-scope-ii-rx", "ASUS ROG Strix Scope II RX"),
        ],
      },
      {
        id: "asus-rog-flare-claymore",
        name: "Flare / Claymore",
        versions: [
          keyboardVersion("asus-rog-strix-flare", "ASUS ROG Strix Flare"),
          keyboardVersion("asus-rog-strix-flare-ii-animate", "ASUS ROG Strix Flare II Animate"),
          keyboardVersion("asus-rog-claymore-ii", "ASUS ROG Claymore II"),
          keyboardVersion("asus-tuf-gaming-k7", "ASUS TUF Gaming K7"),
          keyboardVersion("asus-tuf-gaming-k3", "ASUS TUF Gaming K3"),
          keyboardVersion("asus-tuf-gaming-k3-gen-2", "ASUS TUF Gaming K3 Gen II"),
        ],
      },
    ],
  },
  {
    id: "hyperx-keyboards",
    name: "HyperX Gaming Keyboards",
    brand: "HyperX",
    type: "keyboard",
    category: "Claviers gaming",
    variants: [
      {
        id: "hyperx-alloy",
        name: "Alloy",
        versions: [
          keyboardVersion("hyperx-alloy-rise", "HyperX Alloy Rise"),
          keyboardVersion("hyperx-alloy-rise-75", "HyperX Alloy Rise 75"),
          keyboardVersion("hyperx-alloy-rise-75-wireless", "HyperX Alloy Rise 75 Wireless"),
          keyboardVersion("hyperx-alloy-origins", "HyperX Alloy Origins"),
          keyboardVersion("hyperx-alloy-origins-core", "HyperX Alloy Origins Core"),
          keyboardVersion("hyperx-alloy-origins-60", "HyperX Alloy Origins 60"),
          keyboardVersion("hyperx-alloy-origins-65", "HyperX Alloy Origins 65"),
          keyboardVersion("hyperx-alloy-elite", "HyperX Alloy Elite"),
          keyboardVersion("hyperx-alloy-elite-2", "HyperX Alloy Elite 2"),
          keyboardVersion("hyperx-alloy-fps", "HyperX Alloy FPS"),
          keyboardVersion("hyperx-alloy-fps-pro", "HyperX Alloy FPS Pro"),
        ],
      },
    ],
  },
  {
    id: "keychron-keyboards",
    name: "Keychron Gaming Keyboards",
    brand: "Keychron",
    type: "keyboard",
    category: "Claviers gaming",
    variants: [
      {
        id: "keychron-he",
        name: "Hall Effect",
        versions: [
          keyboardVersion("keychron-q1-he", "Keychron Q1 HE"),
          keyboardVersion("keychron-q3-he", "Keychron Q3 HE"),
          keyboardVersion("keychron-q5-he", "Keychron Q5 HE"),
          keyboardVersion("keychron-k2-he", "Keychron K2 HE"),
        ],
      },
      {
        id: "keychron-q-max",
        name: "Q Max / Premium",
        versions: [
          keyboardVersion("keychron-q1-max", "Keychron Q1 Max"),
          keyboardVersion("keychron-q2-max", "Keychron Q2 Max"),
          keyboardVersion("keychron-q3-max", "Keychron Q3 Max"),
          keyboardVersion("keychron-q5-max", "Keychron Q5 Max"),
          keyboardVersion("keychron-q6-max", "Keychron Q6 Max"),
          keyboardVersion("keychron-q1-pro", "Keychron Q1 Pro"),
          keyboardVersion("keychron-q3-pro", "Keychron Q3 Pro"),
        ],
      },
      {
        id: "keychron-lemokey",
        name: "Lemokey",
        versions: [
          keyboardVersion("keychron-lemokey-l1", "Keychron Lemokey L1"),
          keyboardVersion("keychron-lemokey-l3", "Keychron Lemokey L3"),
          keyboardVersion("keychron-lemokey-p1", "Keychron Lemokey P1"),
        ],
      },
    ],
  },
  {
    id: "ducky-keyboards",
    name: "Ducky Keyboards",
    brand: "Ducky",
    type: "keyboard",
    category: "Claviers gaming",
    variants: [
      {
        id: "ducky-one",
        name: "One / ProjectD",
        versions: [
          keyboardVersion("ducky-one-2-mini", "Ducky One 2 Mini"),
          keyboardVersion("ducky-one-2-sf", "Ducky One 2 SF"),
          keyboardVersion("ducky-one-2-tkl", "Ducky One 2 TKL"),
          keyboardVersion("ducky-one-3-mini", "Ducky One 3 Mini"),
          keyboardVersion("ducky-one-3-sf", "Ducky One 3 SF"),
          keyboardVersion("ducky-one-3-tkl", "Ducky One 3 TKL"),
          keyboardVersion("ducky-one-3", "Ducky One 3"),
          keyboardVersion("ducky-zero-6108", "Ducky Zero 6108"),
          keyboardVersion("ducky-mecha-mini", "Ducky Mecha Mini"),
          keyboardVersion("ducky-shine-7", "Ducky Shine 7"),
        ],
      },
    ],
  },
  {
    id: "msi-keyboards",
    name: "MSI Gaming Keyboards",
    brand: "MSI",
    type: "keyboard",
    category: "Claviers gaming",
    variants: [
      {
        id: "msi-vigor-strike",
        name: "Vigor / Strike",
        versions: [
          keyboardVersion("msi-strike-600", "MSI Strike 600"),
          keyboardVersion("msi-vigor-gk80", "MSI Vigor GK80"),
          keyboardVersion("msi-vigor-gk71-sonic", "MSI Vigor GK71 Sonic"),
          keyboardVersion("msi-vigor-gk70", "MSI Vigor GK70"),
          keyboardVersion("msi-vigor-gk60", "MSI Vigor GK60"),
          keyboardVersion("msi-vigor-gk50-elite", "MSI Vigor GK50 Elite"),
          keyboardVersion("msi-vigor-gk50-elite-tkl", "MSI Vigor GK50 Elite TKL"),
          keyboardVersion("msi-vigor-gk50-low-profile", "MSI Vigor GK50 Low Profile"),
        ],
      },
    ],
  },
  {
    id: "roccat-keyboards",
    name: "ROCCAT / Turtle Beach Keyboards",
    brand: "ROCCAT",
    type: "keyboard",
    category: "Claviers gaming",
    variants: [
      {
        id: "roccat-vulcan",
        name: "Vulcan",
        versions: [
          keyboardVersion("roccat-vulcan-ii-max", "ROCCAT Vulcan II Max"),
          keyboardVersion("roccat-vulcan-ii-mini", "ROCCAT Vulcan II Mini"),
          keyboardVersion("roccat-vulcan-ii", "ROCCAT Vulcan II"),
          keyboardVersion("roccat-vulcan-tkl-pro", "ROCCAT Vulcan TKL Pro"),
          keyboardVersion("roccat-vulcan-pro", "ROCCAT Vulcan Pro"),
          keyboardVersion("roccat-vulcan-100-aimo", "ROCCAT Vulcan 100 AIMO"),
          keyboardVersion("roccat-vulcan-120-aimo", "ROCCAT Vulcan 120 AIMO"),
          keyboardVersion("roccat-vulcan-121-aimo", "ROCCAT Vulcan 121 AIMO"),
          keyboardVersion("roccat-vulcan-122-aimo", "ROCCAT Vulcan 122 AIMO"),
          keyboardVersion("roccat-vulcan-80", "ROCCAT Vulcan 80"),
        ],
      },
      {
        id: "roccat-magma-pyro",
        name: "Magma / Pyro",
        versions: [
          keyboardVersion("roccat-magma", "ROCCAT Magma"),
          keyboardVersion("roccat-magma-mini", "ROCCAT Magma Mini"),
          keyboardVersion("roccat-pyro", "ROCCAT Pyro"),
        ],
      },
      {
        id: "roccat-legacy-keyboards",
        name: "Legacy",
        versions: [
          keyboardVersion("roccat-horde-aimo", "ROCCAT Horde AIMO"),
          keyboardVersion("roccat-isku-fx", "ROCCAT Isku FX"),
          keyboardVersion("roccat-ryos-mk-pro", "ROCCAT Ryos MK Pro"),
          keyboardVersion("roccat-suora-fx", "ROCCAT Suora FX"),
          keyboardVersion("roccat-sova", "ROCCAT Sova"),
        ],
      },
    ],
  },
  {
    id: "cooler-master-keyboards",
    name: "Cooler Master Keyboards",
    brand: "Cooler Master",
    type: "keyboard",
    category: "Claviers gaming",
    variants: [
      {
        id: "cooler-master-mechanical",
        name: "Mechanical",
        versions: [
          keyboardVersion("cooler-master-mk770", "Cooler Master MK770"),
          keyboardVersion("cooler-master-ck720", "Cooler Master CK720"),
          keyboardVersion("cooler-master-ck721", "Cooler Master CK721"),
          keyboardVersion("cooler-master-sk653", "Cooler Master SK653"),
          keyboardVersion("cooler-master-sk650", "Cooler Master SK650"),
          keyboardVersion("cooler-master-mk730", "Cooler Master MK730"),
          keyboardVersion("cooler-master-ck550", "Cooler Master CK550"),
          keyboardVersion("cooler-master-ck550-v2", "Cooler Master CK550 V2"),
          keyboardVersion("cooler-master-masterkeys-pro-l", "Cooler Master MasterKeys Pro L"),
          keyboardVersion("cooler-master-masterkeys-pro-s", "Cooler Master MasterKeys Pro S"),
        ],
      },
    ],
  },
  {
    id: "glorious-keyboards",
    name: "Glorious Keyboards",
    brand: "Glorious",
    type: "keyboard",
    category: "Claviers gaming",
    variants: [
      {
        id: "glorious-gmmk",
        name: "GMMK",
        versions: [
          keyboardVersion("glorious-gmmk", "Glorious GMMK"),
          keyboardVersion("glorious-gmmk-pro", "Glorious GMMK Pro"),
          keyboardVersion("glorious-gmmk-2-65", "Glorious GMMK 2 65%"),
          keyboardVersion("glorious-gmmk-2-96", "Glorious GMMK 2 96%"),
          keyboardVersion("glorious-gmmk-3", "Glorious GMMK 3"),
          keyboardVersion("glorious-gmmk-3-pro", "Glorious GMMK 3 Pro"),
          keyboardVersion("glorious-gmmk-3-he", "Glorious GMMK 3 HE"),
          keyboardVersion("glorious-gmmk-3-pro-he", "Glorious GMMK 3 Pro HE"),
        ],
      },
    ],
  },
  {
    id: "mountain-keyboards",
    name: "Mountain Keyboards",
    brand: "Mountain",
    type: "keyboard",
    category: "Claviers gaming",
    variants: [
      {
        id: "mountain-everest",
        name: "Everest",
        versions: [
          keyboardVersion("mountain-everest-max", "Mountain Everest Max"),
          keyboardVersion("mountain-everest-core", "Mountain Everest Core"),
          keyboardVersion("mountain-everest-60", "Mountain Everest 60"),
        ],
      },
    ],
  },
  {
    id: "akko-keyboards",
    name: "Akko Gaming Keyboards",
    brand: "Akko",
    type: "keyboard",
    category: "Claviers gaming",
    variants: [
      {
        id: "akko-he-mod",
        name: "MOD / HE",
        versions: [
          keyboardVersion("akko-mod-007b-he", "Akko MOD 007B HE"),
          keyboardVersion("akko-mod-007v3-he", "Akko MOD 007 V3 HE"),
          keyboardVersion("akko-5075b-plus", "Akko 5075B Plus"),
          keyboardVersion("akko-5087s-he", "Akko 5087S HE"),
          keyboardVersion("akko-7th-anniversary-mod-007-pc", "Akko 7th Anniversary MOD 007 PC"),
        ],
      },
    ],
  },
  {
    id: "drunkdeer-keyboards",
    name: "DrunkDeer Keyboards",
    brand: "DrunkDeer",
    type: "keyboard",
    category: "Claviers gaming",
    variants: [
      {
        id: "drunkdeer-he",
        name: "Hall Effect",
        versions: [
          keyboardVersion("drunkdeer-a75", "DrunkDeer A75"),
          keyboardVersion("drunkdeer-a75-pro", "DrunkDeer A75 Pro"),
          keyboardVersion("drunkdeer-g65", "DrunkDeer G65"),
          keyboardVersion("drunkdeer-g75", "DrunkDeer G75"),
        ],
      },
    ],
  },
  {
    id: "fnatic-keyboards",
    name: "Fnatic Keyboards",
    brand: "Fnatic",
    type: "keyboard",
    category: "Claviers gaming",
    variants: [
      {
        id: "fnatic-streak",
        name: "Streak",
        versions: [
          keyboardVersion("fnatic-streak", "Fnatic Streak"),
          keyboardVersion("fnatic-ministreak", "Fnatic miniSTREAK"),
          keyboardVersion("fnatic-streak65", "Fnatic Streak65"),
          keyboardVersion("fnatic-streak65-lp", "Fnatic Streak65 LP"),
        ],
      },
    ],
  },
  {
    id: "alienware-keyboards",
    name: "Alienware Keyboards",
    brand: "Alienware",
    type: "keyboard",
    category: "Claviers gaming",
    variants: [
      {
        id: "alienware-aw",
        name: "AW Series",
        versions: [
          keyboardVersion("alienware-aw920k", "Alienware AW920K"),
          keyboardVersion("alienware-aw510k", "Alienware AW510K"),
          keyboardVersion("alienware-aw410k", "Alienware AW410K"),
          keyboardVersion("alienware-aw768", "Alienware AW768"),
        ],
      },
    ],
  },
  {
    id: "apple-keyboards",
    name: "Apple Keyboards",
    brand: "Apple",
    type: "keyboard",
    category: "Claviers premium",
    variants: [
      {
        id: "apple-magic-keyboard",
        name: "Magic Keyboard",
        versions: [
          keyboardVersion("apple-magic-keyboard", "Apple Magic Keyboard"),
          keyboardVersion("apple-magic-keyboard-touch-id", "Apple Magic Keyboard Touch ID"),
          keyboardVersion("apple-magic-keyboard-numeric", "Apple Magic Keyboard Numeric"),
        ],
      },
    ],
  },
];
